import { useCallback } from 'react';
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { DEEPLINK_MODAL_STORAGE_KEY } from './LinkModal';

export function useDontShowAgain(sourceId: string) {
  const [map, setMap] = useLocalStorage(DEEPLINK_MODAL_STORAGE_KEY, new Map<string, boolean>(), {
    deserializer: deserialize,
    serializer: serialize,
  });

  const isChecked = map.get(sourceId) === true;

  const check = useCallback(
    (value: boolean) => {
      setMap(new Map(map).set(sourceId, value));
    },
    [map, setMap, sourceId],
  );

  return { isChecked, check };
}

function serialize(value: Map<string, boolean>) {
  return JSON.stringify(Array.from(value.entries()));
}

function deserialize(value: string) {
  try {
    return new Map<string, boolean>(JSON.parse(value));
  } catch (error) {
    localStorage.removeItem(DEEPLINK_MODAL_STORAGE_KEY);
    return new Map<string, boolean>();
  }
}
